import React from 'react';
import { Card as MuiCard, CardHeader, CardContent, CardActions, Divider } from '@mui/material';
import PropTypes from 'prop-types';

const Card = ({ title, subheader, children, actions, ...props }) => {
  return (
    <MuiCard elevation={2} {...props}>
      {title && (
        <>
          <CardHeader title={title} subheader={subheader} />
          <Divider />
        </>
      )}
      <CardContent>{children}</CardContent>
      {actions && (
        <>
          <Divider />
          <CardActions>{actions}</CardActions>
        </>
      )}
    </MuiCard>
  );
};

Card.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  children: PropTypes.node.isRequired,
  actions: PropTypes.node,
};

export default Card;
